import React, { ReactElement, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initProducts } from 'reactApp/modules/products/products.module';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import Content from 'reactApp/ui/Content/Content';
import Dialog from 'reactApp/ui/Dialog/Dialog';
import { createGaSender } from 'reactApp/utils/ga';
import { EPaymentGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { useBigFileModalCallbacks } from './hooks/useBigFileModalCallbacks';
import { useContent } from './hooks/useContent';
import { useSubscription } from './hooks/useSubscription';
import styles from './UploadBigFileDialog.css';
import { Props } from './UploadBigFileDialog.types';

const sendGa = createGaSender('upload-big-file');

export const UploadBigFileDialog = React.memo(function UploadBigFileDialog(props: Props): ReactElement {
    const { numberOfFiles, onClose: closeModal, skipFileLoading, continueFileLoading, file, files, showProTariff } = props;
    const fileSizeBytes = props.file?.sizeBytes || props.files?.sizeBytes;
    const subscription = useSubscription(showProTariff);
    const callbacks = useBigFileModalCallbacks({ closeModal, skipFileLoading, continueFileLoading, sendGa, subscription, fileSizeBytes });
    const modalContent = useContent({ subscription, numberOfFiles, file, files, callbacks });
    const header = useMemo(() => <div className={styles.header}>{modalContent.header}</div>, [modalContent.header]);
    const dispatch = useDispatch();
    const productsState = useSelector(ProductsSelectors.getLifeCycleState);

    useEffect(() => {
        dispatch(initProducts());
    }, []);

    useEffect(() => {
        sendGa('show', subscription.showTariffType);
        sendPaymentGa({ action: EPaymentGa.bigFileModal, label: 'view', size_offer: fileSizeBytes });
    }, []);

    return (
        <Dialog open header={header} closeOnDimmerClick={false} id="upload-big-file" className={styles.root} onCancel={callbacks.onClose}>
            <Content isModal isLoading={productsState.isLoading}>
                <div className={styles.content}>{modalContent.annotation}</div>
                {modalContent.actions}
            </Content>
        </Dialog>
    );
});
